import React, { useEffect } from 'react';
import styles from './css/Layout.module.css'
import Box from "@mui/material/Box";

import { Route, Switch, useHistory } from "react-router-dom";
import AsideNav from "./layout/AsideNav";
import TopNav from "./layout/TopNav";
import Loading from "./layout/Loading";

import Exhibition from "page/exhibition/Exhibition";
import Audio from "page/audio/Audio";
import ExhibitionEdit from "page/exhibition/ExhibitionEdit";
import Login from "page/Login";
import Commentator from "page/commentator/Commentator";
import Account from "page/account/Account";
import ExhibitionCreate from "page/exhibition/ExhibitionCreate";
import CommentatorCreate from "page/commentator/CommentatorCreate";
import AccountCreate from "page/account/AccountCreate";

import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import store from "reducers/store";
import { commonActions } from "reducers/common";
import { authClear } from "service/util/authClear";

const AppRouter = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const isLoggedIn = useSelector(state => state.commonData.isLoggedIn);
    const isLoading = useSelector(state => state.commonData.isLoading);
    const token = localStorage.getItem('accessToken');
    const login = localStorage.getItem('login');
    useEffect(() => {
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.accessToken}`;
            store.dispatch(commonActions.setToken(localStorage.accessToken));
        }
    }, [token]);
    useEffect(() => {
        if (login === null || login === false) {
            if (window.location.pathname !== "/login") {
                authClear();
                dispatch(commonActions.setLogout());
                history.push("/login");
            }
        }
        if (login) {
            switch (window.location.pathname) {
                case "/setting/exhibition"
                    : history.push("/setting/exhibition")
                    break;
                case "/setting/exhibition/:id"
                    : history.push("/setting/exhibition")
                    break;
                case "/setting/create/exhibition"
                    : history.push("/setting/create/exhibition")
                    break;
                case "/setting/audio"
                    : history.push("/setting/audio")
                    break;
                case "/setting/commentator"
                    : history.push("/setting/commentator")
                    break;
                case "/setting/create/commentator"
                    : history.push("/setting/create/commentator")
                    break;
                case "/setting/account"
                    : history.push("/setting/account")
                    break;
                case "/setting/create/account"
                    : history.push("/setting/create/account")
                    break;
                default
                    : history.push("/setting/exhibition");

            }
        }
    }, [login, dispatch, history])
    return (
        <>
            {isLoggedIn && login ?
                <Box sx={{ display: 'flex' }} className={`${styles.wrapper} ${isLoading ? styles.isLoading : ''}`}>
                    <TopNav />
                    <AsideNav />
                    <Box component="main" className={styles.container} sx={{ flexGrow: 1, p: 3 }}>
                        <Switch>
                            <>
                                <Route exact path={"/setting/exhibition"} component={Exhibition} />
                                <Route exact path={"/setting/exhibition/:id"} component={ExhibitionEdit} />
                                <Route exact path={"/setting/create/exhibition"} component={ExhibitionCreate} />
                                <Route exact path={"/setting/audio"} component={Audio} />
                                <Route exact path={"/setting/commentator"} component={Commentator} />
                                <Route exact path={"/setting/create/commentator"} component={CommentatorCreate} />
                                <Route exact path={"/setting/account"} component={Account} />
                                <Route exact path={"/setting/create/account"} component={AccountCreate} />
                            </>
                        </Switch>
                    </Box>
                </Box>
                : <Route exact path={"/login"} component={Login} />
            }
            {isLoading && <Loading />}
        </>
    );
};

export default AppRouter;